import React, { useContext } from 'react';
import { IVideosAssignmentContext, VideosAssignmentContext } from '../../videosAssignmentState/videosAssignmentContext';
import { ModalToConfirm } from 'components/ModalWindows/ModalToConfirm';
import ModalSentSuccessfully from 'components/ModalWindows/ModalSentSuccessfully';
import ModalSentError from 'components/ModalWindows/ModalSentError';
import classNames from 'classnames';
import style from './ModalWindows.module.scss';

const ModalWindows: React.FC = () => {
	const { resetChanges, updateModuleDataAfterSaving, changeTypeOfModalWindow, sendChanges, typeOfModalWindow } =
		useContext<IVideosAssignmentContext>(VideosAssignmentContext);

	const containerClasses = classNames(style.container, { [style.visible]: typeOfModalWindow });

	const handleConsentEvent = () => {
		resetChanges();
		updateModuleDataAfterSaving();
		changeTypeOfModalWindow(null);
	};

	return (
		<div className={containerClasses} data-test="ModalWindows">
			<ModalToConfirm
				onConsentEvent={resetChanges}
				onFailureEvent={() => changeTypeOfModalWindow(null)}
				isVisible={typeOfModalWindow === 'toConfirmFieldsClearing'}
				description="cancelSaveInfo"
			/>
			<ModalToConfirm
				onConsentEvent={sendChanges}
				onFailureEvent={() => changeTypeOfModalWindow(null)}
				isVisible={typeOfModalWindow === 'toConfirmSendChanges'}
				description="saveInfo"
			/>
			<ModalSentSuccessfully
				onConsentEvent={handleConsentEvent}
				isVisible={typeOfModalWindow === 'success'}
				description="savedSuccessfully"
			/>
			<ModalSentError
				onConsentEvent={() => changeTypeOfModalWindow(null)}
				isVisible={typeOfModalWindow === 'error'}
				description="errorWhileSaving"
			/>
		</div>
	);
};

export default ModalWindows;
